var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dF fC min-h-screen bh-layout"},[_c('air-topbar'),_c('transition',{attrs:{"name":_vm.settings.routerAnimation,"mode":"out-in"}},[_c('router-view',{staticClass:"f1"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }